import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { DLMenu, Icon, Table } from 'appSrc/components/UI';
import EditAdvertiserModal from '../../Modals/Advertiser/EditAdvertiserModal';
import style from './styles/style.module.css';

class MismatchedDomainsTable extends PureComponent {
    constructor( props ) {
        super( props );
        this.state = {
            recordIndexInEdit: null,
        };
    }
    recordHasAllDomainsFromAPI = ( updatedRecordIndex, updatedAdvertiser ) => {
        let apiDomains = this.props.domainDifferences[ updatedRecordIndex ].api.domains;
        let advertiserDomains = updatedAdvertiser.advertisers_domains.map( domain => domain.domain );
        let hasAllDomains = true;
        for ( let i = 0; i < apiDomains.length; i++ ) {
            if ( advertiserDomains.indexOf( apiDomains[i] ) === -1 ) {
                hasAllDomains = false;
            }
        }
        return hasAllDomains;
    }
    openEditModal = ( recordIndex ) => {
        this.setState( { recordIndexInEdit: recordIndex } );
    }
    onEditSubmit = ( updatedAdvertiser ) => {
        let recordDeleted = ( updatedAdvertiser === undefined );
        let updatedRecordIndex = this.state.recordIndexInEdit;

        this.setState( { recordIndexInEdit: null }, () => {
            // if advertiser was deleted, remove it from the list
            if ( recordDeleted ) {
                this.props.removeRecordFromUI && this.props.removeRecordFromUI( updatedRecordIndex );
            }
            // if advertiser was updated, check if it has the domain(s) from the API
            else if ( updatedAdvertiser ) {
                // if all domains match, remove it from the list
                if ( this.recordHasAllDomainsFromAPI( updatedRecordIndex, updatedAdvertiser ) ) {
                    this.props.removeRecordFromUI && this.props.removeRecordFromUI( updatedRecordIndex );
                }
                // else, update the existing record
                else {
                    this.props.updateRecordFromUI && this.props.updateRecordFromUI( updatedRecordIndex, updatedAdvertiser );
                }
            }
        } );
    }
    onEditClose = () => {
        this.setState( { recordIndexInEdit: null } );
    }
    render() {
        const { domainDifferences } = this.props;
        const { recordIndexInEdit } = this.state;

        let recordInEdit = ( recordIndexInEdit !== null ) ? domainDifferences[ recordIndexInEdit ] : null;

        return (
            <div>
                <div className={ style.dataHeader }>Mismatched Domains</div>
                <Table>
                    <Table.Head>
                        <Table.Row>
                            <Table.Cell>AFFILIATE TYPE</Table.Cell>
                            <Table.Cell>ADVERTISER ID</Table.Cell>
                            <Table.Cell>ADVERTISER NAME</Table.Cell>
                            <Table.Cell>DOMAINS</Table.Cell>
                            <Table.Cell>ACTIONS</Table.Cell>
                        </Table.Row>
                    </Table.Head>
                    <Table.Body>
                        { domainDifferences &&
                            domainDifferences.map( ( record, index ) => {
                                return (
                                    <Table.Row key={`${ record.db.affiliate }-${ record.db.advertiserId }-${index}`}>
                                        <Table.Cell>{ record.db.affiliate }</Table.Cell>
                                        <Table.Cell>{ record.db.advertiserId }</Table.Cell>
                                        <Table.Cell>{ record.db.advertiserName }</Table.Cell>
                                        <Table.Cell>
                                            Missing domain(s) from affiliate API:
                                            { record.api.domains.map( ( domain ) => {
                                                return (
                                                    <div key={ domain }>{ domain }</div>
                                                );
                                            } ) }
                                            <br />
                                            DB:
                                            { record.db.domains.map( ( domain ) => {
                                                return (
                                                    <div key={ domain }>{ domain }</div>
                                                );
                                            } ) }
                                        </Table.Cell>
                                        <Table.Cell>
                                            <DLMenu
                                            icon={ ( <Icon source='fontAwesome' className='dropdown' icon='fas/faEllipsisH' style={ { color: '#6461ec' } } faSize='2x' /> ) }
                                            direction='left' >
                                                <DLMenu.Item text='Edit'
                                                onClick={ () => {
                                                    this.openEditModal( index );
                                                } }/>
                                            </DLMenu>
                                        </Table.Cell>
                                    </Table.Row>
                                );
                            } )
                        }
                    </Table.Body>
                </Table>
                { recordInEdit &&
                    <EditAdvertiserModal closeModal={ this.onEditClose }
                    onSubmit={ this.onEditSubmit }
                    advertiser={ {
                        advertiserid: recordInEdit.db.dbAdvertiserId,
                        advertiser_name: recordInEdit.db.advertiserName,
                        advertisers_domains: recordInEdit.db.domains.map( domain => {
                            return {
                                domain: domain,
                            };
                        } ),
                    } }
                    affiliateType={ recordInEdit.db.affiliate } />
                }
            </div>
        );
    }
}

export default connect()( MismatchedDomainsTable );
